
import { Injectable } from "@angular/core";
import { AbstractControl, FormGroup, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { BsModalService } from "ngx-bootstrap/modal";
import Swal from "sweetalert2";
import { ModalPopupComponent } from "../components/bussinesspages/user-management/modal-popup/modal-popup.component";
import { GigsumoConstants, USER_TYPE } from "./GigsumoConstants";
import { APPLICANT_STATUS } from "./gigsumoService";
import { UtilService } from "./util.service";

export const MODAL_OPTIONS: any = {
  keyboard: false,
  backdrop: true,
  class: 'modal-md',
  ignoreBackdropClick: true,
};
export const SWAL_WITH_BUTTONS = Swal.mixin({
  customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
  buttonsStyling: false
});

type validField = {
  readonly max: number;
  readonly min: number;
  readonly mintxt: string;
  readonly maxtxt: string;
  readonly patterntxt: string;
  readonly pattern: string | RegExp;
  readonly domain: Array<any>;
};

enum ERROR_MESSAGE {
  FIRSTNAME_MIN = "First Name cannot be empty",
  FIRSTNAME_MAX = "Maximum 20 chars allowed",
  FIRSTNAME_VALID = "Enter Valid First Name",
  LASTNAME_MIN = "Last Name cannot be empty",
  LASTNAME_MAX = "Maximum 40 chars allowed",
  LASTNAME_VALID = "Enter Valid Last Name",
  NUMBER_PATTERN = "Please enter only numerals (0-9)",
  TARGETRATE_PATTERN = "Enter valid target rate",
  PHONE_MAX = "Maximum 15 chars allowed",
  PHONE_MIN = "Minimum 10 chars required",
  TARGETRATE_MIN = "Target Rate cannot be empty",
  TARGETRATE_MAX = "Max 8 chars allowed",
  STATE_MAX = "Max 50 chars allowed",
  ZIPCODE_MAX = "Max 11 chars allowed",
  ZIPCODE_MIN = "Min 4 chars required",
  RANGE_ERROR = "Please check your ranges",
  CITY_MAX = "Max 50 chars allowed",
  CLIENTNAME_MIN = "Client Name cannot be empty",
  CLIENTNAME_MAX = "Maximum 75 chars allowed",
  JOBTITLE_MIN = "Job Title cannot be empty",
  JOBTITLE_MAX = "Maximum 150 chars allowed",
  EMAIL_MAX = "Maximum 50 chars allowed",
  EMAIL_VALID = "Enter a valid email address",
  EMAIL_DOMAIN = "Enter Valid domain",
  BUSINESSPHONE_MIN = "Minimum 10 chars required",
  BUSINESSPHONE_MAX = "Maximum 15 chars allowed",
  TAGLINE_MAX = "Maximum 100 chars allowed",
  TAGLINE_PATTERN = "Enter valid TagLine",
  HTTP_VALID = "Enter Valid Url",
  BUSINESS_ADDRESS_MIN = "Address cannot be empty",
  BUSINESS_ADDRESS_MAX = "Maximum 50 chars allowed",
  ORGANIZATION_NAME_MAX = "Maximum 100 chars allowed",
  ORGANIZATION_NAME_MIN = "Organization Name cannot be empty",
  SCHOOL_NAME_MIN = "Minimum 3 chars required",
  SCHOOL_NAME_MAX = "Maximum 50 chars allowed",
  DEGREE_MAX = "Maximum 50 chars allowed",
  SPECIALITY_MAX = "Maximum 50 chars allowed",
  CERTIFICATION_NAME_MIN = "Certification Name cannot be empty",
  CERTIFICATION_NAME_MAX = "Maximum 50 chars allowed",
  CERTIFICATION_ORG_MIN = "Certifying Organization cannot be empty",
  CERTIFICATION_ORG_MAX = "Maximum 50 chars allowed",
  CERTIFICATION_LICENSE_MIN = "License Number cannot be empty",
  CERTIFICATION_LICENSE_MAX = "Maximum 50 chars allowed",
  TEAMNAME_MAX = "Maximum 30 chars allowed",
  TEAMNAME_MIN = "Minimum 5 chars required",
  TEAMNAME_PATTERN = "Name must contain alphabet only",
  TEAM_DESCRIPTION = "Maximum 100 words allowed",
  ABOUTME_MIN = "Minimum 100 characters required",
  ABOUTME_MAX = "Maximum characters allowed is 1000",
  ABOUT_YOURSELF_MAX = "Maximum characters allowed is 2000",
  ABOUT_YOUR_MAX = " Maximum 3000 characters allowed",
  ABOUT_YOUR_MIN = " Minimum 100 characters required",
  COMMUNITY_MAX = " Maximum 10000 characters allowed",
  PITCH_MAX = "Maximum 150 characters allowed",
  ABOUT_MAX = " Maximum 1000 words allowed",
  ABOUT_COMPANY_MAX = " Maximum 1000 characters allowed",
  ABOUT_COMPANY_MIN = " Minimum 100 words required",
  IMAGE_TYPE_VALID = "Please upload the correct file type (Only .jpg, .png, .jpeg)",
  IMAGE_VIDEO_VALID = "Please upload the correct file type( Only JPG, JPEG, PNG and GIF)",
  GIGSUMONO = "Maximum 15 chars allowed",
  GIGSUMOMIN = "Please enter valid gigsumo id",
  PLATFORM_BUSINESSID = "Maximum 13 chars allowed",
  ORG_MAX = "Maximum 250 chars allowed",
}

@Injectable({
  providedIn: "root"
})
export class FormValidation {
  public isInvalid: boolean = false;
  MemberShipType: string = localStorage.getItem("MemberShipType");
  readonly IMAGE_ERROR: string = "Please upload file upto 10 MB";
  readonly ORGNAME: Partial<validField> = { max: 250 };
  readonly NETWORK_NAME: Partial<validField> = { pattern: "^[a-zA-Z ]*$", min: 5, max: 30 }
  readonly MAX_GIGSUMONO: Partial<validField> = { max: 15 };
  readonly UPGRADE_USER: string = `You are already in ${this.MemberShipType} plan, once your limit is over then you can upgrade again.`;
  readonly TEAM_NAME: Partial<validField> = { pattern: "^[a-zA-Z ]*$", min: 5, max: 30 }
  readonly TEAM_DESCRIPTION: Partial<validField> = { max: 100 }
  readonly FIRST_Name: Partial<validField> = { pattern: "^[a-zA-Z ]*$", max: 20 };
  readonly LAST_NAME: Partial<validField> = { pattern: "^[a-zA-Z ]*$", max: 40 };
  readonly PHONE: Partial<validField> = { min: 10, max: 15, pattern: '[0-9]*\.?[0-9]*' };
  readonly ABOUT_COMPANY: Partial<validField> = { min: 100, max: 1000 };
  readonly CANDIDATE_ABOUT: Partial<validField> = { min: 100, max: 2600 }
  readonly ABOUT_ME: Partial<validField> = { min: 100, max: 3000 };
  readonly PITCH: Partial<validField> = { min: 0, max: 150 };
  readonly ABOUT_YOURSELF: Partial<validField> = { min: 100, max: 2000 };
  readonly COMMUNITY_ME: Partial<validField> = { min: 100, max: 10000 };
  readonly STATE: Partial<validField> = { max: 50 };
  readonly CITY: Partial<validField> = { max: 50 };
  readonly TARGET_RATE: Partial<validField> = { pattern: '[1-9][0-9]*', max: 8 };
  readonly OTP: Partial<validField> = { pattern: '[0-9]*\.?[0-9]*', max: 6 };
  readonly CLIENT_NAME: Partial<validField> = { max: 75 };
  readonly BUSINESS_NAME: Partial<validField> = { max: 100, pattern: "^[a-zA-Z ]*$" };
  readonly TAG_LINE: Partial<validField> = { pattern: "^[a-zA-Z ]*$", max: 100 };
  readonly JOT_TITLE: Partial<validField> = { max: 149 };
  readonly ZIPCODE: Partial<validField> = { max: 11, min: 4 };
  readonly JOB_DESCRIPTION: Partial<validField> = { min: 100, max: 10000 };
  readonly RESUME_SUMMARY: Partial<validField> = { min: 100, max: 3000 };
  readonly EMAIL: Partial<validField> = {
    pattern: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    max: 50,
    domain: ["com", "net", "org", "info"],
  };
  readonly BUSINESS_PHONE: Partial<validField> = { pattern: '[0-9]*\.?[0-9]*', min: 10, max: 15 };
  readonly BUSINESS_ADDRESS: Partial<validField> = { max: 50 };
  readonly DEGREE: Partial<validField> = { max: 50 };
  readonly SPECIALITY: Partial<validField> = { max: 50 };
  readonly CERTIFICATION_NAME_ORG_LICENSE: Partial<validField> = { max: 50 };
  readonly ORGANIZATION_NAME: Partial<validField> = { max: 100 };
  readonly PLATFORM_BUSINESSID: Partial<validField> = { max: 13 };
  readonly SCHOOL_NAME: Partial<validField> = { min: 3, max: 50 };
  readonly SOCIAL_LINK: Partial<validField> = { pattern: '^(https?://)?((([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})|localhost)(:\\d+)?(\\/\\S*)?(\\?\\S*)?$' };
  readonly IMAGE_TYPE: Array<any> = ['image/jpg', 'image/jpeg', 'image/png'];

  ref: any;


  constructor() {
  }


  get Form() {
    return ERROR_MESSAGE;
  }
  convertSmallCase(data: string) {
    if (data != null) {
      // Handle the special case for "ON HOLD"
      if (data === 'ON HOLD') {
        return 'On Hold';
      }

      if(data === 'DRAFTED'){
        return 'Draft';
      }

      const [d, ...rest] = data;
      let restValue = rest.join("");
      restValue = restValue.includes("_") ? restValue.replace(/_/g, "") : restValue;
      return d + restValue.toLowerCase();
    }
  }


  titleCase([d, ...rest]: string | any) {
    return d.toUpperCase() + rest.toString().replaceAll(",", "");
  }

  convertUserType(val: string) {
    let data = val.split("_");
    let [f, ...rest] = data[0];
    let [s, ...rest2] = data[1];
    return f + rest.join("").toLowerCase() + " " + s + rest2.join("").toLowerCase();
  }

  getHours(val: string) {
    switch (val) {
      case "Hourly":
        return "per hour";
      case "Daily":
        return "per day";
      case "Monthly":
        return "per month";
      case "Weekly":
        return "per weekly";
      case "Yearly":
        return "per yearly";
      default:
        break;
    }
  }

  isInteger(event) {
    var ctl = document.getElementById('myText');
    var startPos = ctl['selectionStart'];

    if (startPos == 0 && String.fromCharCode(event.which) == '0') {
      return false;
    }
  }

  getClasName(value: string) {
    return value === "ON HOLD" ? "ONHOLD" : value;
  }
  APPLICANT_STATUS_COLOR: Array<{ key: APPLICANT_STATUS, padding: string, color: string, background: string }> = [
    { key: 'CANDIDATE-SELECTED', padding: '12px 6px', color: '#0a5f0b', background: '#d8f5d8' },
    { key: 'PROFILE-REJECTED', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'ONBOARDED', padding: '12px 6px', color: '#5c8c0d', background: '#edffd2' },
    { key: 'PREONBOARDED', padding: '12px 6px', color: '#0d7182', background: '#d6f5fa' },
    { key: 'INTERVIEW-SCHEDULED', padding: '12px 6px', color: '#1a8d19', background: '#dffbdf' },
    { key: 'INTERVIEW SCHEDULED', padding: '12px 6px', color: '#1d6fa7', background: '#d9eefb' },
    { key: 'L1-INTERVIEW', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'L2-INTERVIEW', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'L3-INTERVIEW', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'L1 INTERVIEW', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'L2 INTERVIEW', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'L3 INTERVIEW', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'CANDIDATE-SHORTLISTED', padding: '12px 6px', color: '#1d7576', background: '#daf3f3' },
    { key: 'SHORTLISTED', padding: '12px 6px', color: '#1d6fa7', background: '#d9eefb' },
    { key: 'PRE-ONBOARDED', padding: '12px 6px', color: '#039171', background: '#d0f9ef' },
    { key: 'OFFER-WITHDRAWN', padding: '12px 6px', color: '#a00100', background: '#ffe0e0' },
    { key: 'WITHDRAW', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'INTERVIEW-ACCEPTED', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'INTERVIEW-REJECTED', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'OFFER-DECLINED', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'OFFER-ACCEPTED', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'ACTIVE', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'FILLED', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'CLOSED', padding: '12px 6px', color: '#5a5a5a', background: '#eeeeee' },
    { key: 'INACTIVE', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'INITIATED', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'RESUME-PENDING', padding: '12px 6px', color: '#b37400', background: '#fff0d6' },
    { key: 'INTERVIEW-FAILED', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'ACCEPTED', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'REJECTED', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'OFFER DECLINED', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'JOB-APPLIED', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'OFFERED', padding: '12px 6px', color: '#748500', background: '#f3f9d3' },
    { key: 'CANDIDATE-WITHDRAWN', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'CANDIDATE BACKOUT', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'OFFER WITHDRAWN', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'ON HOLD', padding: '12px 6px', color: '#cc6a51', background: '#ffeae5' },
    { key: 'BLOCKED', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'UNAVAILABLE', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'DRAFTED', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    // Added for the Recent Submissions badge (bench dashboard) — these submission
    // statuses reach the feed but had no colour entry, so getStyle() returned a
    // blank style. Colours mirror their canonical siblings (JOB-APPLIED teal /
    // CANDIDATE-SELECTED green / REJECTED red).
    { key: 'SUBMITTED', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'CANDIDATE-SUBMITTED', padding: '12px 6px', color: '#2d7a6c', background: '#e0f5f1' },
    { key: 'SELECTED', padding: '12px 6px', color: '#0a5f0b', background: '#d8f5d8' },
    { key: 'APPLICATION-REJECTED', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },
    { key: 'CANDIDATE-REJECTED', padding: '12px 6px', color: '#d40000', background: '#ffe5e5' },

  ];

  getStyle(status: APPLICANT_STATUS) {
    const find = this.APPLICANT_STATUS_COLOR.find(p => p.key === status);
    return find ? { color: find.color, background: find.background } : { border: '', color: '', background: '' };
  }

  // Standard display form for a raw backend status/enum: every separator
  // spelling ('L1-INTERVIEW', 'L1_INTERVIEW', 'L1 INTERVIEW') renders as
  // 'L1 Interview'. Use as the fallback wherever a status would otherwise
  // reach the template unmapped.
  formatStatusLabel(value: string): string {
    if (!value) return '';
    return String(value)
      .replace(/[-_]+/g, ' ')
      .trim()
      .toLowerCase()
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  get MONTHS(): Array<any> {
    return [
      { code: 1, name: "January" },
      { code: 2, name: "February" },
      { code: 3, name: "March" },
      { code: 4, name: "April" },
      { code: 5, name: "May" },
      { code: 6, name: "June" },
      { code: 7, name: "July" },
      { code: 8, name: "August" },
      { code: 9, name: "September" },
      { code: 10, name: "October" },
      { code: 11, name: "November" },
      { code: 12, name: "December" },
    ];
  }

  validSpace(evt) {
    evt = (evt || window.event);
    return this.willCreateWhitespaceSequence(evt) ? false : true;
  }

  checkImageSize(file: File): number {
    // finding fileSize
    const Filesize: number = file && (file.size / 1024 / 1024);
    return Math.abs(Filesize);
  }

  static extractContent(value: string): string {
    let span = document.createElement('span');
    span.innerHTML = value;
    return span.textContent || span.innerText;
  };


  getStatus(value: string) {
    if (value === "ACTIVE") {
      return "Available";
    }
    else if (value === "INACTIVE") {
      return "Unavailable";
    }
  }

  isWhiteSpace(char) {
    return (/\s/).test(char);
  }

  updateControl(data: { value: string, form: UntypedFormGroup }, status: string = "SET") {
    if (status.includes("CLEAR")) {
      data.form.get(data.value).clearValidators();
      data.form.get(data.value).updateValueAndValidity();
      data.form.get(data.value).reset();
    }
    else {
      data.form.get(data.value).setValidators([Validators.required]);
      data.form.get(data.value).updateValueAndValidity();
    }

  }
  companyminmaxWords(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value || control.value.trim() === '') return null; // Skip if empty
      const strippedText = this.stripHtmlTags(control.value);
      const wordCount = this.countWords(strippedText);

      if (wordCount < min) {
        return { minword: true };
      }
      if (wordCount > max) {
        return { maxword: true };
      }
      return null;
    };
  }

  companyMinMaxCharacters(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // Handle null, undefined, or empty string cases
      if (!control.value || control.value.trim() === '') {
        // Explicitly clear any existing errors by returning null
        return null;
      }

      const strippedText = this.stripHtmlTags(control.value);
      const characterCount = strippedText.length;

      // Double-check if stripped text is empty after HTML removal
      if (characterCount === 0) {
        return null;
      }

      if (characterCount < min) {
        return { minchar: { actualLength: characterCount, requiredLength: min } };
      }
      if (characterCount > max) {
        return { maxchar: { actualLength: characterCount, maxLength: max } };
      }

      return null;
    };
  }
  remainingCharacters: number = 0;
  updateRemainingCharacters(field: string, value: string = ''): void {
    const strippedText = this.stripHtmlTags(value);
    const characterCount = strippedText.length;
    const maxLengths = {
      resumeSummary: this.ABOUT_ME.max,
      community: this.COMMUNITY_ME.max,
      aboutYourself: this.ABOUT_YOURSELF.max
    };

    this.remainingCharacters = Math.max(maxLengths[field] - characterCount, 0);
  }
  stripHtmlTags(text: string): string {
    const div = document.createElement('div');
    div.innerHTML = text;
    return div.textContent || div.innerText || '';
  }


  remainingWords: number = this.ABOUT_COMPANY.max;
  updateRemainingWords(value: string = ''): void {
    const strippedText = this.stripHtmlTags(value);
    const wordCount = this.countWords(strippedText);
    this.remainingWords = Math.max(this.ABOUT_COMPANY.max - wordCount, 0);
  }

  countWords(text: string): number {
    const normalizedText = text.trim().replace(/\s+/g, ' ');
    return normalizedText.split(' ').filter(word => word.length > 0).length;
  }


  getTextBasedOnStatus(status: string, content: string): string {
    let textContent: string;
    switch (status) {
      case GigsumoConstants.ACTIVE: textContent = `${content} successfully`
        break;
      case GigsumoConstants.DRAFTED: textContent = `${content} successfully`
        break;
      case GigsumoConstants.AWAITING_HOST:
        content = content === "Job created" ? content.substring(0, 3) : content.substring(0, 9)
        textContent = `The ${content} will become ${content === "Job" ? "active" : "available"} on the Effective date selected`
        break;
      default: textContent = `${content} successfully`;
    }
    return textContent;
  }

  // throwPopup(value: SweetAlertOptions): Promise<SweetAlertResult<any>> {
  //   return Swal.fire({
  //     title: value.title,

  //   })
  // }
  getCurrency(country: string): string {
    switch (country) {
      case 'US': return 'USD';
      case 'IN': return 'INR';
      case 'CA': return 'CAD';
      case 'AU': return 'AUD';
      default: return 'CUR';
    }
  }

  // CEIPAL jobs carry their own currency from the ATS; only USD/INR/CAD/AUD
  // are supported in the UI, anything else displays as CUR.
  getJobCurrency(job: any): string {
    if (job?.source === 'CEIPAL') {
      const cur = (job?.currency ?? '').toString().trim().toUpperCase();
      return ['USD', 'INR', 'CAD', 'AUD'].indexOf(cur) !== -1 ? cur : 'CUR';
    }
    return this.getCurrency(job?.country);
  }

  getPayType(payType: string): string {
    switch (payType) {
      case 'Hourly': return 'Hr';
      case 'Daily': return 'Day';
      case 'Weekly': return 'Week';
      case 'Monthly': return 'Month';
      case 'Yearly': return 'Year';
      default: return '';
    }
  }



  dateInPast(date: Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  }


  dateInFuture(date: Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date >= today;
  }

  willCreateWhitespaceSequence(evt) {
    var willCreateWSS = false;
    if (this.isWhiteSpace(evt.key)) {

      var elmInput: HTMLInputElement = evt.currentTarget;
      var content = elmInput.value;

      var posStart = elmInput.selectionStart;
      var posEnd = elmInput.selectionEnd;
      console.log((/\s/).test(content.charAt(posStart - 1)), (/\s/).test(content.charAt(posEnd)));

      willCreateWSS = (
        this.isWhiteSpace(content[posStart - 1] || '')
        || this.isWhiteSpace(content[posEnd] || '')
      );
    }
    return willCreateWSS;
  }
  decimalFilter(event: any) {
    const reg = /^-?\d*(\.\d{0,8})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
    this.validatezeo(event);
  }
  validatezeo(event) {
    var ctl = document.getElementById('myText');
    if (ctl instanceof HTMLInputElement) {
      var startPos = ctl.selectionStart;

      if (startPos == 0 && String.fromCharCode(event.which) == '0') {
        return false;
      }
    }
  }

  public findDiffrenceBetweenDates(date1: Date, date2: Date) {
    let diffMillis = date1.getTime() - date2.getTime();
    return (diffMillis / (1000 * 3600 * 24));
  }

  validSpace_specialCharacters(evt) {

    evt = (evt || window.event);
    var charCode = (evt.which || evt.keyCode);

    return ((charCode > 32)
      && (charCode < 65 || charCode > 90)
      && (charCode < 97 || charCode > 122))
      || this.willCreateWhitespaceSequence(evt) ? false : true;
  }


  countArr(arr: Array<any>): number {
    let val = arr.reduce((acc, curr) => {
      acc += curr
      return acc;
    }, 0);

    return val;
  }


  getPercentage(value: number, total: number) {
    return ((value * 100) / total) + '%'
  }

  isFull(percentage): boolean {
    const v = +percentage.split('%')[0];
    return v >= 100;
  }

  isHalf(percentage): boolean {
    const v = +percentage.split('%')[0];
    return v >= 50;
  }

  isQuarter(percentage): boolean {
    const v = +percentage.split('%')[0];
    return v <= 50;
  }

  isLow(percentage): boolean {
    const v = +percentage.split('%')[0];
    return v <= 10;
  }


  getClassStyle(val, total) {
    const percentage = this.getPercentage(val, total);

    if (this.isFull(percentage)) {
      return 'bg-primary';
    }
    else if (this.isLow(percentage)) {
      return 'bg-danger';
    }
    else if (this.isHalf(percentage)) {
      return 'bg-primary';
    }
    else if (this.isQuarter(percentage)) {
      return 'bg-warning';
    }

  }

  restrictSymbols(event) {
    const allowedCharacters = /[0-9]/;
    const allowedText = /[0-9\.]/g;
    const char = String.fromCharCode(event.which);
    if ((!allowedCharacters.test(char) && !allowedText.test(char)) || event.which === 46) {
      event.preventDefault();
    }
  }
  isModalOpen: boolean = false;
  openView(title: string, data: any[], modalService: BsModalService, util: UtilService): void {
    if (this.isModalOpen) {
      return;
    }
    this.isModalOpen = true;

    util.startLoader();

    const initialState: any = {
      title: title,
      fields: data,
    };
    modalService.show(ModalPopupComponent, { ...MODAL_OPTIONS, initialState });

    modalService.onHide.subscribe(() => {
      this.isModalOpen = false;
    });

    setTimeout(() => {
      util.stopLoader();
    }, 500);
  }



  curryObject(obj: any, key1: string) {
    return (key2: string) => {
      return obj[key1][key2];
    }
  }

  enableOrDisableFields(form: FormGroup, fields: Array<any>, enable = true) {
    for (let key of fields) {
      if (enable) {
        form.get(key).enable();
      }
      else {
        form.get(key).disable();
      }
    }

  }


  resetFieldsExcept(form: FormGroup, fields: Array<any>) {
    Object.keys(form.controls).forEach(x => {
      if (!fields.includes(x)) {
        form.get(x).reset();
      }
    });
  }

  get isFreelanceOrJobSeeker() {
    const userType = localStorage.getItem('userType') as USER_TYPE;
    return userType === "FREELANCE_RECRUITER" || userType === "JOB_SEEKER";
  }

}
